import type { ReactNode } from 'react';

export const symbol_decimal_decrease: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m586-210 52 52q9 9 9 21.5t-9.05 21.5q-9.06 9-21.5 9-12.45 0-21.45-9L492-219q-9-9-9-21t9-21l103-104q9.07-9 21.53-9 12.47 0 21.47 9 9 9 9 21t-9 21l-52 53h254q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H586ZM150-440h-40q-12.75 0-21.37-8.63Q80-457.25 80-470v-40q0-12.75 8.63-21.38Q97.25-540 110-540h40q12.75 0 21.38 8.62Q180-522.75 180-510v40q0 12.75-8.62 21.37Q162.75-440 150-440Zm131-41q-41-41-41-99v-160q0-58 41-99t99-41q58 0 99 41t41 99v160q0 58-41 99t-99 41q-58 0-99-41Zm155.5-42.33Q460-546.67 460-580v-160q0-33.33-23.26-56.67Q413.47-820 380.24-820q-33.24 0-56.74 23.33Q300-773.33 300-740v160q0 33.33 23.26 56.67Q346.53-500 379.76-500q33.24 0 56.74-23.33Z"
		/>
	</svg>
);
